module.exports = "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAwCdASoZABkAPpFCnEqlo6KhqAgAsBIJZwDImBat8gAA/vMgidk73A/Q0Z8dGe1eqaVs2NL4AAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/Ocean_Veil.webp
// module id = jS0K
// module chunks = 14